export type BannerDesign =
  | 'services-list' | 'photo-wide' | 'three-up' | 'strip'
  | 'bundle' | 'coupon' | 'ladder' | 'due-next';

export interface CustomerPromotionRow {
  label: string;
  priceCents: number;
  wasCents: number | null;
  percentOff: number | null;
}

export interface CustomerPromotion {
  id: number;
  name: string;
  headline: string | null;
  body: string | null;
  finePrint: string | null;
  bannerDesign: BannerDesign;
  imageUrl: string | null;
  endsAt: string | null;
  totalCents: number | null;
  wasTotalCents: number | null;
  /** The redeemable code from `promo_codes`, joined server-side by `promo_code_id`. Null when the promotion has none. */
  promoCode: string | null;
  rows: CustomerPromotionRow[];
}

export interface BannerProps {
  promotion: CustomerPromotion;
  brandColor?: string;
}

/** One money formatter for all eight, so no banner can round differently from another. */
export const money = (cents: number | null | undefined): string =>
  `$${(((cents ?? 0) as number) / 100).toFixed(2)}`;

export const sumRows = (rows: CustomerPromotionRow[]): number =>
  rows.reduce((total, row) => total + (row.wasCents ?? row.priceCents), 0);
